function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSiteGradientTerrestrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 21.166666 21.166667",
    id: "svg19093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-275.83332)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950617,
      strokeOpacity: 1
    },
    id: "rect4518-85-4-5",
    width: 21.166666,
    height: 21.166666,
    x: -5.5511151e-17,
    y: 275.83331,
    rx: 10.583333,
    ry: 10.583333
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#925214",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19206792,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0",
    width: 18.520834,
    height: 18.520834,
    x: 1.3229064,
    y: 277.15622,
    rx: 9.260417,
    ry: 9.260417
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.23597811,
      strokeOpacity: 1
    },
    d: "m 11.416895,282.55776 c -0.841122,0 -2.1719877,2.26517 -2.1735106,2.78239 -0.00151,0.51721 1.5570476,1.67028 1.5570476,2.0176 0,0.34731 -0.03874,0.65704 -0.474943,0.65704 -0.4361956,0 -1.9590137,-3.09711 -2.4200068,-3.09709 -0.460993,10e-6 -3.6982817,3.45989 -3.2753807,4.19237 0.422901,0.73249 11.5916315,0.54493 11.9062485,0 0.314618,-0.54493 -4.278334,-6.55231 -5.119455,-6.55231 z",
    id: "rect4563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiteGradientTerrestrial);
export default __webpack_public_path__ + "static/media/icon-site-gradient-terrestrial.10fd17d00de74be384972b57d4be2a1a.svg";
export { ForwardRef as ReactComponent };